import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.IncidentAlreadyClaimedPopUp.title',
    defaultMessage: 'Oops! This is a duplicate',
  },
  oops: {
    id: 'src.pages.IncidentAlreadyClaimedPopUp.oops',
    defaultMessage: 'Looks like you already have a claim for {riskUnit} for this date. Please continue with your existing claim from your dashboard.',
  },
  continue: {
    id: 'src.pages.IncidentAlreadyClaimedPopUp.continue',
    defaultMessage: 'Return to dashboard',
  },
  cancel: {
    id: 'src.pages.IncidentAlreadyClaimedPopUp.cancel',
    defaultMessage: 'Cancel',
  },
});
